import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { useGetQMSProfile } from '@vindr/services/actions/qms.action';
import ModalQMS from '@vindr/workspace-core/modules/QMS/components/ModalQMS';
import { useGlobalState } from '@vindr/workspace-core/contexts/GlobalContext';
import { PERMISSIONS } from '@vindr/services/constants/permissions.constant';
const { Title } = Typography;

export default function OrderListHeader({ totalItem, onCollapse, collapsed }) {
  const { message: messageApi, keycloak } = useGlobalState();
  const { t } = useTranslation('Vindoc');
  const [openQMS, setOpenQMS] = useState(false);
  const qmsOrderDefault = useGetQMSProfile({
    enabled: keycloak.hasOneOfPerm([PERMISSIONS.qms.profile])
  })?.data?.data?.qms_order_default;

  return (
    <div className="flex min-h-12 shrink-0 flex-wrap items-center justify-between space-x-2 border-b border-gray-800 pb-3">
      <Title level={4} className="m-0">
        {t('Order List')}
        <span className="ml-1">
          ({totalItem || 0} {t('items')})
        </span>
      </Title>
      <div className="flex items-center space-x-2">
        {keycloak.hasOneOfPerm([PERMISSIONS.order.qms]) && <Button
          className={`batch-button flex items-center justify-center text-base`}
          size="small"
          onClick={() => {
            if (!qmsOrderDefault) {
              messageApi.error('QMS is not configured. Please configure QMS first.');
              return;
            }
            setOpenQMS(true);
          }}
          // icon={<UploadOutlined />}
          style={{ width: 90 }}
          // disabled={!keycloak.hasOneOfPerm([PERMISSIONS.studylist.upload])}
        >
          {t('QMS')}
        </Button>}
        <Button
          className={`batch-button flex items-center justify-center text-base`}
          size="small"
          onClick={() => onCollapse()}
          style={{ width: 90 }}
        >
          {collapsed ? t('Expand') : t('Collapse')}
        </Button>
      </div>
      <ModalQMS
        qmsId={qmsOrderDefault?.id}
        open={openQMS}
        type={qmsOrderDefault?.type}
        setOpen={setOpenQMS}
      />
    </div>
  );
}
